import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.styles.scss';

export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-left">
          © {new Date().getFullYear()} <a target="_blank" href='https://kivotos.tech/'>kivots.tech</a>
        </div>
        <div className="footer-right">
          <Link to="/">Home</Link>
          <Link to="/schedule">Schedule</Link>
          <a href="mailto:info@kivotos.tech">Contact</a>
        </div>
      </div>
    </footer>
  );
}
